import { useQuery, useMutation } from '@tanstack/react-query';
import { ProfileAPI } from '@newo/api/gateway';
import type { TProfileData } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const profileAPI = new ProfileAPI(axios);

type IQueryKeys = {
    getProfile: () => [string];
};
export const QUERY_KEYS: IQueryKeys = {
    getProfile: () => ['profile']
};

// GET Profile
export const useProfileQuery = (isEnabled?: boolean) => {
    return useQuery({
        queryKey: QUERY_KEYS.getProfile(),
        queryFn: async () => profileAPI.getProfile(),
        enabled: isEnabled
    });
};

// UPDATE Profile
export const useUpdateProfileMutation = () => {
    return useMutation({
        mutationFn: async ({ data }: { data: Partial<TProfileData> }) =>
            profileAPI.updateProfile(data)
    });
};

// GET Billing
export const useBillingQuery = () => {
    return useQuery({
        queryKey: ['billing'],
        queryFn: async () => profileAPI.getBilling()
    });
};
